import { render, staticRenderFns } from "./OvertimeApproverList.vue?vue&type=template&id=cb9f20a0&"
import script from "./OvertimeApproverList.vue?vue&type=script&lang=ts&"
export * from "./OvertimeApproverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports